// Componente único "← Voltar" — PEDIDO_EMERGENT_CORES_VOLTAR_COTAS_UNICO.
//
// Comportamento:
// - Se o usuário veio de outra tela do mesmo app, volta no histórico (goBack).
// - Se abriu direto (link externo, notificação, WhatsApp), vai para a tela
//   "pai" via a prop `fallback` (ex.: "/equipe", "/clientes", "/pipeline").
// Estilo: secundário, altura 36px (desktop) / 44px (mobile), fonte 14px,
// posição canto superior esquerdo acima do título — quem usa coloca este
// botão como primeira coisa dentro da página.
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "@/components/icons";

export default function Voltar({ fallback = "/", label = "Voltar", className = "" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const onClick = () => {
    const hasHistory = (location.key && location.key !== "default")
      || (typeof window !== "undefined" && window.history.length > 1 && document.referrer);
    if (hasHistory) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="btn-voltar"
      className={`inline-flex items-center gap-1 h-11 md:h-9 px-3 rounded-lg bg-white border border-slate-200 text-sm font-medium text-navy hover:bg-slate-50 transition-colors ${className}`}
    >
      <ArrowLeft className="w-4 h-4" />
      <span>{label}</span>
    </button>
  );
}
